function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M45 18V13.5H43.5V9H42V7.5H40.5V6H39V4.5H37.5V3H34.5V1.5H28.5V0H18V1.5H12V3H9V4.5H7.5V6H6V7.5H4.5V9H3V13.5H1.5V18H0V28.5H1.5V33H3V37.5H4.5V39H6V40.5H7.5V42H9V43.5H12V45H18V46.5H28.5V45H34.5V43.5H37.5V42H39V40.5H40.5V39H42V37.5H43.5V33H45V28.5H46.5V18H45Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 18V13.5H43.5V9H42V7.5H40.5V6H39V4.5H37.5V3H34.5V1.5H28.5V0H18V1.5H12V3H9V4.5H7.5V6H6V7.5H4.5V9H3V13.5H1.5V18H0V28.5H1.5V33H3V37.5H4.5V39H6V40.5H7.5V42H9V43.5H12V45H18V46.5H28.5V45H34.5V43.5H37.5V42H39V40.5H40.5V39H42V37.5H43.5V33H45V28.5H46.5V18H45ZM30.75 32.25H29.25V33.75H20.25V29.25H23.25V32.25H27.75V24.75H26.25V23.25H21.75V21.75H23.25V20.25H24.75V18.75H26.25V17.25H20.25V24.75H23.25V27.75H18.75V26.25H17.25V17.25H15.75V15.75H17.25V14.25H18.75V12.75H20.25V15.75H29.25V17.25H27.75V20.25H26.25V21.75H27.75V23.25H29.25V24.75H30.75V32.25Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTez);
export default __webpack_public_path__ + "static/media/tez.3ee64e73c8ece9d1a1617886c30a980c.svg";
export { ForwardRef as ReactComponent };